export default __webpack_public_path__ + "static/media/pie_1.1d1047b4.svg";